import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InstitutionService {
    private baseUrl = 'https://api.example.com/institution'; // replace with your API endpoint

    constructor(private http: HttpClient) { }

    getInstitutionDetails(): Observable<any> {
        // Simulated API response — replace with actual API call
        return of({
            name: 'Siddaganga Institute of Technology',
            domain: 'sit.ac.in',
            type: 'Engineering College',
            format: 'Semester',
            email: 'admin@sit.ac.in',
            address: 'Tumkur, Karnataka, India'
        });

        // For real API:
        // return this.http.get(`${this.baseUrl}/details`);
    }

    updateInstitution(payload: any): Observable<any> {
        return this.http.put(`${this.baseUrl}/update`, payload);
    }
}
